export default __webpack_public_path__ + "static/media/Mysore hostel_2.e254af45.jpg";